import { Toaster, toast } from 'sonner';
import { useEffect } from 'react';

interface PromiseResolve {
  loading: string;
  text: string;
  error: string;
}

export type ToastType = 'success' | 'info' | 'error' | 'warning' | 'promise' | 'default';

interface ToastProps {
  message: string;
  type: ToastType;
  promiseResolve?: PromiseResolve | Promise<any>;
  toastKey: number;
}

export const Toast: React.FC<ToastProps> = ({ message, type, promiseResolve, toastKey }) => {
  useEffect(() => {
    if (message) {
      if (type === 'success') {
        toast.success(message);
      } else if (type === 'info') {
        toast.info(message);
      } else if (type === 'error') {
        toast.error(message);
      } else if (type === 'warning') {
        toast.warning(message);
      } else if (type === 'promise' && promiseResolve) {
        if (promiseResolve instanceof Promise) {
          // Handle when promiseResolve is a Promise
          toast.promise(promiseResolve, {
            loading: 'Loading...',
            success: message,
            error: 'An error occurred',
          });
        } else {
          // Handle when promiseResolve is a PromiseResolve object
          toast.promise(Promise.resolve(message), {
            loading: promiseResolve.loading,
            success: () => promiseResolve.text,
            error: promiseResolve.error,
          });
        }
      } else {
        toast(message);
      }
    }
  }, [message, type, promiseResolve, toastKey]);

  return <Toaster 
    position="top-center"
    toastOptions={{
      style: {
        padding: '16px',
      }
    }}
  />;
};
